import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, LogOut, Search, Moon, Sun } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { useTheme } from '@/hooks/useTheme';
import { toast } from '@/hooks/use-toast';

interface CmsTopBarProps {
  onMenuClick: () => void;
  onSearchClick?: () => void;
}

const CmsTopBar: React.FC<CmsTopBarProps> = ({ onMenuClick, onSearchClick }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();

  const handleLogout = () => {
    logout();
    toast({
      title: 'Одјавени сте',
      description: 'Успешно се одјавивте од вашиот профил.',
    });
    navigate('/');
  };

  return (
    <header className="h-14 border-b border-border bg-background flex items-center justify-between px-4 shrink-0">
      <button
        onClick={onMenuClick}
        className="md:hidden p-2 rounded-md text-muted-foreground hover:bg-accent"
      >
        <Menu className="w-5 h-5" />
      </button>

      <div className="md:hidden" />

      {/* Search trigger */}
      {onSearchClick && (
        <button
          onClick={onSearchClick}
          className="hidden md:flex items-center gap-2 text-sm text-muted-foreground border border-border rounded-md px-3 py-1.5 hover:bg-accent transition-colors"
        >
          <Search className="w-4 h-4" />
          <span>Пребарувај...</span>
          <kbd className="ml-2 pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground">
            <span className="text-xs">⌘</span>K
          </kbd>
        </button>
      )}

      <div className="flex items-center gap-3">
        <Button variant="ghost" size="sm" onClick={toggleTheme} title={theme === 'dark' ? 'Светла тема' : 'Темна тема'}>
          {theme === 'dark' ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
        </Button>
        <span className="text-sm text-muted-foreground hidden sm:block">
          {user?.name}
        </span>
        <Button variant="ghost" size="sm" onClick={handleLogout}>
          <LogOut className="w-4 h-4 mr-1" />
          <span className="hidden sm:inline">Одјави се</span>
        </Button>
      </div>
    </header>
  );
};

export default CmsTopBar;
